import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 0,
    margin: "0 0 30px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 25px",
  },
  heading: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    fontSize: "2em",
    fontWeight: 300,
  },
  image: {
    [theme.breakpoints.down("xs")]: {
      width: "140px",

      height: "35px",
    },
  },
  icon: {
    marginLeft: "5px",
    marginTop: "5px",
    [theme.breakpoints.down("xs")]: {
      height: "30px",
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    width: "400px",
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  profile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "auto",
    [theme.breakpoints.down("xs")]: {
      marginTop: 20,
      justifyContent: "center",
    },
  },
  Avatar: {
    marginRight: "5px",
  },
  // userName: {
  //   display: "flex",
  //   alignItems: "center",
  //   textAlign: "center",
  //   margin: " 0 1rem",

  //   [theme.breakpoints.up("xs")]: {
  //     marginLeft: "20px",
  //   },
  // },
  brandContainer: {
    display: "flex",
    alignItems: "center",
  },
  purple: {
    color: "#FFF",
    backgroundColor: "#f50057c2",
    "&:hover": {
      backgroundColor: "#f50057 !important",
    },
  },
  "MuiMenuItem-root": {
    width: "200px",
  },
  signin: {
    [theme.breakpoints.down("xs")]: {
      paddingRight: "8px",
      paddingLeft: "8px",
      marginLeft: "5px",
    },
  },
}));
